import { createAction } from '@reduxjs/toolkit';

export const PROCESS_IN_CALL_SEARCHED_RESULT_SET_TYPE = 'saga/processInCallSearchedResultSet';
export const processInCallSearchedResultSetAction = createAction(PROCESS_IN_CALL_SEARCHED_RESULT_SET_TYPE);
